<template>
  <div class="Market">
    <el-tabs v-model="active_name" type="card" @tab-click="handleClick">
      <el-tab-pane label="Product List" name="first">
        <MarketList v-if="active_name==='first'"></MarketList>
      </el-tab-pane>
      <el-tab-pane label="Create Product" name="second">
        <MarketCreate @back="onListTap" v-if="active_name==='second'" pid="0"></MarketCreate>
      </el-tab-pane>
      <el-tab-pane label="Manage Category" name="third">
        <MarketCategory v-if="active_name==='third'"></MarketCategory>
      </el-tab-pane>
      <el-tab-pane label="Manage Options" name="fourth">
        <MarketOptions v-if="active_name==='fourth'"></MarketOptions>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import MarketOptions from '@/components/Market/MarketOptions/MarketOptions'
  import MarketCategory from "@/components/Market/MarketCategory/MarketCategory";
  import MarketList from "@/components/Market/MarketList/MarketList";
  import MarketCreate from "@/components/Market/MarketCreate/MarketCreate";
  export default {
    props: {},
    components:{
      MarketCategory,
      MarketOptions,
      MarketList,
      MarketCreate
    },
    data: () => {
      return {
        active_name: 'first'
      }
    },
    methods: {
      onListTap(){
        this.active_name = 'first'
      },
      handleClick(tab) {
        this.active_name = tab.paneName
      }
    },
    beforeMount(){
      this.active_name = this.$route.params.target?this.$route.params.target:"first"
    },
  };

</script>
